import { get } from 'lodash';
import { createSelector } from 'reselect';

const root = state => get(state, 'RecipeSearchState');

export const getRecipes = createSelector(
  state => get(root(state), 'searchResults', []),
  result => result
);

export const getHasNextPage = state => get(root(state), 'hasNextPage');

export const getLoadingRecipes = state => get(root(state), 'loadingRecipes');

export const getPageSize = state => get(root(state), 'pageSize');



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/state/selectors.js